import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Header, Footer } from '../components/common';
import { getBlogPostById } from '../data/blogPosts';
import '../components/common/PageLayout.css';
import './Blog.css';
import './BlogDetail.css';

const BlogDetail = () => {
  const { postId } = useParams();
  const post = getBlogPostById(postId);

  if (!post) {
    return (
      <>
        <div className="hero-gradient-wrap">
          <Header ctaText="Join Community" ctaPath="#courses" />
          <section className="page-hero">
            <h1>Blog</h1>
          </section>
        </div>
        <main className="page-layout-main">
          <section className="page-section blog-detail-not-found">
            <p>Post not found.</p>
            <Link to="/blog">← Back to Blog</Link>
          </section>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <div className="hero-gradient-wrap">
        <Header ctaText="Join Community" ctaPath="#courses" />
        <section className="page-hero">
          <h1>Blog</h1>
        </section>
      </div>
      <main className="page-layout-main">
        <article className="blog-detail">
          <div className="blog-detail-header">
            <Link to="/blog" className="blog-detail-back">← Back to Blog</Link>
            <span className="blog-detail-category">{post.category}</span>
            <time className="blog-detail-date" dateTime={post.date}>{post.date}</time>
            <h1 className="blog-detail-title">{post.title}</h1>
          </div>
          <div className="blog-detail-image-wrap">
            <img src={post.image} alt="" className="blog-detail-image" loading="lazy" />
          </div>
          <div
            className="blog-detail-content"
            dangerouslySetInnerHTML={{ __html: post.content.trim() }}
          />
        </article>
      </main>
      <Footer />
    </>
  );
};

export default BlogDetail;
